<template>
  <div class="claim-wof-container">
    <v-card class="claim-wof-wrapper">
      <!-- <v-card-title>
        <label class="--v-primary-base text-left text-capitalize mr-4">{{ $t(`label.claimVoucher`) }}</label>
      </v-card-title>                     :rules="validator.requiredRules(4, 15)" -->
      <v-card>
        <div style="background-color: #F3F5F6;">
          <div class="claim-wof-page-container">
            <div class="d-flex pa-3 align-center">
              <img loading="lazy" width="30px" height="30" src="/static/image/reward/Profile_Wheel.png" />
              <h3 class="white--text pl-3">{{ $t(`luckyWheel.spintitle`) }}</h3>
            </div>
            <div class="px-3 pb-5" style="width: 60%">
              <label class="white--text" style="font-size: 12px">Amazing 3 Wheel at Bhai88 and enjoy exclusive benefits today !</label>
            </div>
            <div class="wof-container pb-3 px-3">
              <v-row no-gutters align="center" class="wof-container-button-button">
                <v-col cols="12" style="display: flex; justify-content: center;">
                  <app-button class="button-claim-voucher white--text" :action="this.navigateWOFPage" :readonly="!codeIsValid" :title="$t(`label.spinNow`)"></app-button>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card>
    </v-card>
    <!-- <app-dialog :dialogShow="msgDialog.show" :max-width="1100" :title="msgDialog.title" :closeAction="this.onCloseClick">
      <v-container :class="[$vuetify.breakpoint.mdAndDown ? 'px-3' :'px-5', $vuetify.breakpoint.smAndDown ? 'maxFrameHeight' :'fill-height']">
        <div v-html="msgDialog.msg" class="cms_bonus_content"></div>
        <v-btn class="full-width font-weight-bold pa-2 buttonPrimary primary-button theme--light" @click="onCloseClick()">{{ $t(`label.ok`) }}
        </v-btn>
      </v-container>
    </app-dialog> -->
    <app-dialog :dialogShow="msgDialog.show" ref="claimVoucherDetailDialog" :max-width="400" :title="voucherObj.code" :header_title="'editProfile'" :closeAction="this.onCloseClick">
      <v-row no-gutters justify="center" :class="$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5'">
        <v-col cols="6">
          <label class="wof-claim-dialog-title">{{ $t(`field.bonusAmount`) }}</label>
        </v-col>
        <v-col cols="6" class="text-right" v-if="voucherCheck.data.bonusIsPercentage">
          {{ voucherCheck.data.bonusPercentage }}
        </v-col>
        <v-col cols="6" class="text-right" v-else>
          {{ voucherCheck.data.bonusGivenAmount }}
        </v-col>
        <v-col cols="6" class="mt-2 mb-6">
          <label class="wof-claim-dialog-title">{{ $t(`field.targetTurnover`) }}</label>
        </v-col>
        <v-col cols="6" class="text-right mt-2 mb-6">
          {{ voucherCheck.data.bonusTargetRollover }}
        </v-col>
        <v-col cols="8">
          <v-btn height="auto" @click="applyVoucher" color="primary" depressed class="primary-button theme-button text-capitalize pa-2 font-weight-bold white--text">{{ $t(`label.confirm`) }}</v-btn>
        </v-col>
      </v-row>
    </app-dialog>
  </div>
</template>

<script>
import AppGameCard from '../../components/home/GameCard'
import { formValidator, locale, errorCodeHelper, uiHelper } from '@/util'
import { GRAB_COIN_SETTING, VOUCHER_BONUS_APPLY, VOUCHER_BONUS_APPLY_RESET, VOUCHER_BONUS_CHECK, VOUCHER_BONUS_CHECK_RESET } from '../../store/bonus.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import { DevicePlatform } from '@/constants/enums'
import { WHEEL_MODULE } from '@/store/wheel.module'
export default {
  name: 'wofComponent',
  components: {
    AppGameCard
  },
  data: () => ({
    validator: formValidator,
    voucherObj: {
      code: ''
    },
    msgDialog: {
      show: false,
      title: '',
      msg: ''
    },
    codeIsValid: false,
    voucherCheck: {
      data: {}
    }
  }),
  computed: {
    voucherCheckResult() {
      return this.$store.state.bonus.checkVoucherResponse.complete
    },
    voucherApplyResult() {
      return this.$store.state.bonus.applyVoucherResponse.complete
    },
    voucherCode() {
      return this.voucherObj.code
    }
  },
  watch: {
    voucherApplyResult() {
      if (this.$store.state.bonus.applyVoucherResponse.complete) {
        this.openResultDialog(this.$store.state.bonus.applyVoucherResponse)
      }
    },
    voucherCheckResult() {
      if (this.$store.state.bonus.checkVoucherResponse.complete) {
        this.voucherCheck = this.$store.state.bonus.checkVoucherResponse
        this.openConfirmDialog(this.voucherCheck)
      }
    }
  },
  created() {
    this.metaTag()
  },
  methods: {
    metaTag() {
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      }
    },
    getWOF() {
      let currency = uiHelper.getCurrency()
      let filter = {
        currency: currency
      }
      this.$store.dispatch(`${WHEEL_MODULE}`, { filter })
    },
    getGrabCoinSetting() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${GRAB_COIN_SETTING}`, { filter })
    },
    navigateToCoinPage() {
      if (this.$route.params.lang) {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            lang: this.$route.params.lang,
            tab: 'deposit'
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            tab: 'deposit'
          }
        })
      }
    },
    navigateToDailyCheckIn() {
      // this.$router.push({
      //   name: ROUTE_NAME.REWARDS
      // })
      if (this.$route.params.lang) {
        this.$router.push({
          name: ROUTE_NAME.REWARDS,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.REWARDS
        })
      }
    },
    onClaimVoucherClick() {
      if (this.$refs.codeForm.validate()) {
        const voucherObj = this.voucherObj
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK}`, {
          voucherObj
        })
      }
    },
    openResultDialog(result) {
      if (result.code != 0 && !result.success) {
        this.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(result.code))
      } else {
        this.$parent.openAlert(true, locale.getMessage(`message.voucherBonusApplied`))
      }
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      this.$store.dispatch(`${VOUCHER_BONUS_APPLY_RESET}`)
    },
    openConfirmDialog(result) {
      if (result.code != 0 && !result.success) {
        this.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(result.code))
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      } else {
        this.msgDialog.show = true
      }
    },
    applyVoucher() {
      const voucherObj = this.voucherObj
      this.$store.dispatch(`${VOUCHER_BONUS_APPLY}`, {
        voucherObj
      })
      this.msgDialog.show = false
    },
    onCloseClick() {
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      this.msgDialog.show = false
    }
  }
}
</script>

<style lang="scss">
.claim-wof-page-container {
  background-size: cover;
  background-image: url(/static/image/reward/wheel_background.png);
  .button-claim-voucher {
    width: 100%;
    height: 56px;
    font-size: 14px !important;
    border-radius: 4px;
    color: #000000 !important;
    background: #ffc000 !important;
  }
}
.fillinvoucher .v-text-field fieldset,
.v-text-field .v-input__control,
.fillinvoucher .v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-top: 10px;
}
.dots span {
  position: absolute;
  width: 6px;
  height: 6px;
  display: block;
  border-radius: 50%;
  top: 235px;
  transform: translateY(-50%);
  background-color: #fff;
}
.dots span:nth-child(1) {
  width: 30px;
  height: 30px;
  left: 7px;
}
.dots span:nth-child(2) {
  width: 30px;
  height: 30px;
  right: 7px;
}
.wof-container {
  //background-image: url(/static/image/reward/voucher.png);
  //background-size: cover;
  //border-radius: 30px !important;
  //margin-left: 12px;
  //margin-right: 12px;
}
.wof-container-button {
  height: 40%;
  width: 100%;
  //background: url(/static/image/reward/Purple_line.png);
  //border-bottom-left-radius: 30px !important;
  //border-bottom-right-radius: 30px !important;
  //background-repeat: no-repeat;
  //background-size: cover;
  display: flex;
  justify-content: center;
}
.claim-wof-container {
  max-width: 1240px;
  margin: auto;

  .claim-wof-wrapper {
    max-width: 744px;
    margin: auto;
    background: var(--v-background-lighten2);
  }
}
.wof-card {
  height: 80%;
}
.wof-claim-dialog-title {
  color: #acacac;
}
@media screen and (min-width: 750px) {
  .dots span {
    top: 250px;
  }
  .dots span:nth-child(1) {
    width: 30px;
    height: 30px;
    left: 23px;
  }
  .dots span:nth-child(2) {
    width: 30px;
    height: 30px;
    right: 23px;
  }
}
</style>
